export default __webpack_public_path__ + "static/home-top-bg-b7ccbc52226b73c9c0401e1f0f20b410.webp";